module.exports = __webpack_public_path__ + "static/img/exclusive-modal-bg.5041464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exclusive-modal-bg.png
// module id = 950
// module chunks = 117